import { useMemo } from 'react'

import { ArticleList, IArticleListItem } from 'src/components/molecules'

import { IDocumentUpdateEntity } from '../types'

interface IFundUpdatesMobileListProps {
  documents: IDocumentUpdateEntity[]
  onDocumentClick?: (document: IDocumentUpdateEntity) => void
}

const formatMeta = (document: IDocumentUpdateEntity): string =>
  `${document.categoryDisplayLabel} · ${document.displayDate}`

export const FundUpdatesMobileList = ({
  documents,
  onDocumentClick,
}: IFundUpdatesMobileListProps): JSX.Element => {
  const items: IArticleListItem[] = documents.map(
    (document): IArticleListItem => ({
      id: document.id,
      title: document.documentTitle,
      meta: formatMeta(document),
    }),
  )

  const documentsById = useMemo(
    (): Map<string, IDocumentUpdateEntity> =>
      new Map(
        documents.map((document): [string, IDocumentUpdateEntity] => [
          document.id,
          document,
        ]),
      ),
    [documents],
  )

  const handleItemClick = onDocumentClick
    ? (item: IArticleListItem): void => {
        const document = documentsById.get(item.id)
        if (document) {
          onDocumentClick(document)
        }
      }
    : undefined

  return (
    <ArticleList
      items={items}
      ariaLabel="Fund updates"
      onItemClick={handleItemClick}
    />
  )
}
